import React, { DetailedHTMLProps, Fragment, HTMLAttributes } from 'react';

import { isBoolean, isString, isNumber } from 'util';
import { withStyles, Grid } from '@material-ui/core';

const Max12 = (value: IColNum, valueO: IColNum): IColNum =>
  value > 12 ? valueO : value;

const checkCol = (
  colWs: [IColNum, IColNum],
  dWs: number[]
): [IColNum, IColNum] => {
  const width = colWs[0] + colWs[1];
  if (
    !colWs ||
    colWs.length !== 2 ||
    !isNumber(colWs[0]) ||
    !isNumber(colWs[1]) ||
    width / 12 > 1 ||
    12 % width !== 0
  ) {
    return dWs as [IColNum, IColNum];
  }
  return colWs;
};
export const StyledTitleGridBorder = withStyles({
  item: {
    border: '1px solid #ddd',
    backgroundColor: 'rgb(245, 246, 251)',
    // fontWeight: "bold",
    color: 'rgb(7, 44, 130)',
    padding: '0.6em',
    display: 'flex',
    flexFlow: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    minHeight: 'initial',
  },
})(Grid);
export const StyledGridBorder = withStyles({
  item: {
    border: '1px solid #ddd',
    padding: '0.6em',
    display: 'flex',
    flexFlow: 'wrap',
    alignItems: 'center',
    minHeight: 'initial',
    backgroundColor: 'white',
    '& > div': {
      width: '100%',
    },
  },
})(Grid);

// component-------------------------------------------------
export const PlainText = (
  props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
): JSX.Element => {
  const { children, ...other } = props;
  return (
    <div
      style={{
        fontSize: '1.1em',
        margin: '5px',
        // padding: "0.275em 0.75em",
      }}
      {...other}
    >
      {children}
    </div>
  );
};

export const VcGrid = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
})(Grid);

export const VcEGrid = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
})(Grid);

export const HVcGrid = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})(Grid);

export const TildeGrid = (
  props: HTMLAttributes<HTMLDivElement>
): JSX.Element => {
  const { style = {}, children = '~', ...other } = props;
  return (
    <div
      {...other}
      style={{
        color: '#656565',
        padding: '0 5px',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const MasterGrids = (props: IMasterGrids): JSX.Element => {
  const { id, mGrids = [] } = props;
  let { md = [2, 4], xs = [3, 9] } = props;

  md = checkCol(md, [2, 4]);
  xs = checkCol(xs, [3, 9]);
  const mdW = (md[0] + md[1]) as IColNum;
  const xsW = (xs[0] + xs[1]) as IColNum;

  return (
    <Grid id={id} container>
      {mGrids.map((obj) => {
        const { show = true, t, child, colspan = 1 } = obj;

        const tdMd = (md[1] + (colspan - 1) * (mdW as number)) as IColNum;
        const tdXs = (xs[1] + (colspan - 1) * (xsW as number)) as IColNum;

        return (
          show &&
          (isBoolean(t) && !t ? (
            <StyledGridBorder key={String(t)} item md={mdW} xs={xsW}>
              {child}
            </StyledGridBorder>
          ) : (
            <Fragment key={String(t)}>
              <StyledTitleGridBorder item md={md[0]} xs={xs[0]}>
                <PlainText style={{ margin: '5px 0' }}>
                  {isString(t) && t[0] === '*' ? (
                    <>
                      <span style={{ color: 'red', display: 'contents' }}>
                        *
                      </span>
                      {t.substring(1)}
                    </>
                  ) : (
                    t
                  )}
                </PlainText>
              </StyledTitleGridBorder>
              <StyledGridBorder
                item
                md={Max12(tdMd, md[1])}
                xs={Max12(tdXs, xs[1])}
              >
                {child}
              </StyledGridBorder>
            </Fragment>
          ))
        );
      })}
    </Grid>
  );
};
